import React from 'react'

const Close = () => (
  <svg width="15" height="15" viewBox="0 0 15 15"><path d="M8.778 7.364l5.657 5.657a1 1 0 01-1.414 1.414L7.364 8.778l-5.657 5.657a1 1 0 01-1.414-1.414L5.95 7.364.293 1.707A1 1 0 011.707.293L7.364 5.95 13.021.293a1 1 0 111.414 1.414L8.778 7.364z" fill="#FFF"/></svg>
)

export default Close
